import React, { FC, useCallback } from "react";
import { useNavigate } from "react-router";
import { Layout } from "@lookiero/sty-psp-ui";
import { useGetCompletedOrders } from "../../behaviors/useGetCompletedOrders";
import { Orders as OrdersTemplate } from "../../components/templates/orders/Orders";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { TrackingPage, TrackingView } from "../../tracking/tracking";
import { useTrackPageView } from "../../tracking/useTrackPageView";
import { formatDate as formatDateToLocale } from "./Orders.controller";

interface OrdersProps {
  readonly layout: Layout;
}

const Orders: FC<OrdersProps> = ({ layout }) => {
  const navigate = useNavigate();
  const {
    session: { user },
    tradename,
  } = useStaticInfo();
  const { orders, isLoading } = useGetCompletedOrders();

  useTrackPageView({
    country: user.country,
    segment: user.segment,
    userId: user.id,
    page: TrackingPage.ORDERS,
    view: TrackingView.LOOK_IN_ORDERS,
    tradename,
  });

  const formatDate = useCallback((date: string) => formatDateToLocale(date, user.country), [user.country]);

  const handleOnBack = useCallback(() => navigate(-1), [navigate]);

  return (
    <OrdersTemplate
      formatDate={formatDate}
      isLoading={isLoading}
      layout={layout}
      orders={orders}
      onBack={handleOnBack}
    />
  );
};

export { Orders };
